module.exports = __webpack_public_path__ + "img/dab_saymon.2021a942.jpg";